import { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import Input from "components/common/Input";
import InputPassword from "components/common/InputPassword";
import Button from "components/common/Button";
import Colors from "assets/Colors.js";
import * as Realm from "realm-web";
import { useRealmApp } from "RealmApp";
import { useFormik } from "formik";
import { Carousel, Checkbox, Col, Form, Row } from "antd";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import Logo from "components/icons/Logo";
import LanguageSelector from "containers/SideBarTopMenuHOC/LanguageSelector";
import useScreenSize from "hooks/useScreenSize";
import Footer from "components/common/Footer";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import onboarding3 from "../../assets/images/onboarding3.png";
import onboarding2 from "../../assets/images/onboarding2.png";
import onboarding1 from "../../assets/images/onboarding1.png";
import s from "./styles";
import wallpaper from "../../assets/images/LoginBackground.png";

function Login() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const app = useRealmApp();

  const {
    values,
    setFieldValue,
    handleSubmit,
    dirty,
    errors,
    setErrors,
    touched,
    getFieldProps,
    isValid,
  } = useFormik({
    initialValues: {
      email: "",
      password: "",
      token: undefined,
    },
    onSubmit: (values) => {
      setLoading(true);
      app
        .logIn(
          Realm.Credentials.emailPassword(values.email, values.password),
          history
        )
        .catch(() => {
          setErrors({
            emailOrPasswordError: t("containers.LogIn.emailOrPasswordError"),
          });
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email(t("containers.LogIn.emailError"))
        .required(t("containers.LogIn.emailRequired")),
      password: Yup.string()
        .min(8, t("containers.LogIn.minPasswordError"))
        .required(t("containers.LogIn.passwordRequired")),
    }),
  });

  const onVerify = useCallback((token) => {
    setFieldValue("token", token, false);
  }, []);

  const { height } = useScreenSize();
  return (
    <div>
      <div
        style={{
          minHeight: "100vh",
          height: "100%",
        }}
      >
        <s.headerContainer>
          <a href="/">
            <Logo />
          </a>
          <LanguageSelector login />
        </s.headerContainer>

        <Row>
          <GoogleReCaptcha onVerify={onVerify} />
          <Col xs={24} md={12}>
            <s.formContainer>
              <s.form>
                <s.Title>{t("containers.LogIn.login")}</s.Title>
                <s.line />

                <Form
                  style={{ marginTop: "32px" }}
                  autoComplete="off"
                  onSubmitCapture={handleSubmit}
                >
                  <s.SubTitle>{t("containers.LogIn.email")}</s.SubTitle>
                  <Form.Item
                    style={{
                      marginBottom: "20px",
                    }}
                  >
                    <Input
                      placeholder={t("containers.LogIn.email")}
                      valid={
                        (touched.email && errors.email) ||
                        errors.emailOrPasswordError
                      }
                      value={values.email}
                      {...getFieldProps("email")}
                    />
                    <s.ErrorText visible={errors.email && touched.email}>
                      {errors.email}
                    </s.ErrorText>
                  </Form.Item>
                  <s.SubTitle>{t("containers.LogIn.password")}</s.SubTitle>
                  <Form.Item>
                    <InputPassword
                      placeholder={t("containers.LogIn.password")}
                      values={values.password}
                      valid={
                        (touched.password && errors.password) ||
                        errors.emailOrPasswordError
                      }
                      {...getFieldProps("password")}
                    />
                    <s.ErrorText visible={touched.password && errors.password}>
                      {errors.password}
                    </s.ErrorText>
                  </Form.Item>
                  <Link to="/passwordChangeRequest">
                    <s.ForgotText>
                      {t("containers.LogIn.forgotPass")}
                    </s.ForgotText>
                  </Link>
                  <Checkbox>
                    <s.Remember>{t("containers.LogIn.rememberMe")}</s.Remember>
                  </Checkbox>

                  <Form.Item style={{ marginTop: 32 }}>
                    <Button
                      // type="primary"
                      loading={loading}
                      onClick={handleSubmit}
                      htmlType="submit"
                      style={{
                        background: Colors.primary_web,
                        opacity:
                          values.token && values.password && values.email
                            ? 1
                            : 0.5,
                        color: Colors.text_on_secondary,
                      }}
                      type="submit"
                      disabled={!dirty || !isValid}
                    >
                      {t("containers.LogIn.login")}
                    </Button>
                    <s.ErrorText
                      visible={errors.emailOrPasswordError && touched.password}
                    >
                      {errors.emailOrPasswordError}
                    </s.ErrorText>
                  </Form.Item>
                </Form>
              </s.form>
              {/* <s.NoAccountText>
                {t("containers.LogIn.noAccount")}

                <p
                  style={{
                    marginLeft: "3px",
                    fontWeight: "400",
                  }}
                >
                  <s.register href="/new_user">
                    {t("containers.LogIn.registerNow")}
                  </s.register>
                </p>
              </s.NoAccountText> */}
            </s.formContainer>
          </Col>
          <Col
            xs={0}
            md={12}
            style={{
              backgroundImage: `url(${wallpaper})`,
              minHeight: "100vh",
              height: "auto",
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          >
            <Carousel
              autoplay
              style={{
                height: height < 687 ? "687px" : "100vh",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{}}>
                <s.imageContainer>
                  <img
                    src={onboarding1}
                    style={{ maxWidth: "500px", width: "100%" }}
                  />
                </s.imageContainer>
                <s.textContainer>
                  <div
                    style={{
                      width: "50%",
                      textAlign: "center",
                      color: "white",
                    }}
                  >
                    <s.TitleLeft>
                      {t("containers.LogIn.onboardingTitle")}
                    </s.TitleLeft>
                    <s.SubTitleRight>
                      {t("containers.LogIn.onboardingMessage")}
                    </s.SubTitleRight>
                  </div>
                </s.textContainer>
              </div>
              <div style={{}}>
                <s.imageContainer>
                  <img
                    src={onboarding2}
                    style={{ maxWidth: "500px", width: "100%" }}
                  />
                </s.imageContainer>
                <s.textContainer>
                  <div
                    style={{
                      width: "50%",
                      textAlign: "center",
                      color: "white",
                    }}
                  >
                    <s.TitleLeft>
                      {t("containers.LogIn.onboardingTitle2")}
                    </s.TitleLeft>
                    <s.SubTitleRight>
                      {t("containers.LogIn.onboardingMessage2")}
                    </s.SubTitleRight>
                  </div>
                </s.textContainer>
              </div>
              <div style={{}}>
                <s.imageContainer>
                  <img
                    src={onboarding3}
                    style={{ maxWidth: "500px", width: "100%" }}
                  />
                </s.imageContainer>
                <s.textContainer>
                  <div
                    style={{
                      width: "50%",
                      textAlign: "center",
                      color: "white",
                    }}
                  >
                    <s.TitleLeft>
                      {t("containers.LogIn.onboardingTitle3")}
                    </s.TitleLeft>
                    <s.SubTitleRight>
                      {t("containers.LogIn.onboardingMessage3")}
                    </s.SubTitleRight>
                  </div>
                </s.textContainer>
              </div>
            </Carousel>
          </Col>
        </Row>
      </div>
      <Footer marginTop="-70px" />
    </div>
  );
}

export default Login;
